//#region src/jsonRpc/errors.ts
const CODE_TO_ERROR_TYPE = {
	"-32700": "ParseError",
	"-32701": "OversizedRequest",
	"-32702": "OversizedResponse",
	"-32600": "InvalidRequest",
	"-32601": "MethodNotFound",
	"-32602": "InvalidParams",
	"-32603": "InternalError",
	"-32604": "ServerBusy",
	"-32000": "CallExecutionFailed",
	"-32001": "UnknownError",
	"-32003": "SubscriptionClosed",
	"-32004": "SubscriptionClosedWithError",
	"-32005": "BatchesNotSupported",
	"-32006": "TooManySubscriptions",
	"-32050": "TransientError",
	"-32002": "TransactionExecutionClientError"
};
/**
* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
*/
var SafeHTTPTransportError = class extends Error {};
/**
* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
*/
var JsonRpcError = class extends SafeHTTPTransportError {
	constructor(message, code) {
		super(message);
		this.code = code;
		this.type = CODE_TO_ERROR_TYPE[code] ?? "ServerError";
	}
};
/**
* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
*/
var SafeHTTPStatusError = class extends SafeHTTPTransportError {
	constructor(message, status, statusText) {
		super(message);
		this.status = status;
		this.statusText = statusText;
	}
};
//#endregion
export { JsonRpcError, SafeHTTPStatusError, SafeHTTPTransportError };

//# sourceMappingURL=errors.mjs.map